import React, { Component } from "react";
import { getDataSources } from "../../../services/dataSourceService";
import CustomLoader from "../../common/Loader";
import {
  getDT,
  toFindColumns,
  saveDT,
  getSPV,
  findParameters,
} from "../../../services/formService";
import * as Icon from "react-feather";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ResultSource, RowActions } from "../../../constants/ResultSource";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getProjectForms } from "../../../services/projectService";
import { logActivity } from "../../../services/utilService";

class WDataTable extends Component {
  DataSources = [];
  Forms = [];
  RowActions = [];
  ResultSources = [];
  StoredProcedures = [];
  Views = [];

  state = {
    Project_ID: this.props.Project_ID,
    Form_ID: this.props.Form_ID,
    Widget_ID: this.props.Widget.Widget_ID,
    DT_ID: 0,
    DataSource_ID: 0,
    ResultSource_ID: 0,
    ResultSource_Content: "",
    Action_ID: 0,
    Action_Form_ID: 0,
    Display_Name: "",
    Columns: [],
    Parameters: [],
    can_save: false,
    open_options: "",
    enableServerSidePaging: false,
    enableDownloadDT: false,
    enablePrintDT: false,
    enableFilterDT: false,
    loading: false,
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSPVChange = this.handleSPVChange.bind(this);
  }

  getOptions = async (value) => {
    const { data } = await getSPV(value, this.getConn());
    if (value === ResultSource.SP) {
      this.StoredProcedures = data;
    } else if (value === ResultSource.View) {
      this.Views = data;
    }
  };

  async loadDT() {
    const { data } = await getDT(this.state.Widget_ID);

    let { data: Forms } = await getProjectForms(this.state.Project_ID);
    this.Forms = Forms.filter((form) => form.Form_ID !== this.props.Form_ID);

    this.RowActions = JSON.parse(data.rowActions);
    this.ResultSources = JSON.parse(data.resultSources);
  
    const DT = JSON.parse(data.DT)[0];

    //console.log(DT)
 
    if (DT) {
      this.setState({ DT_ID: DT.DT_ID });
      this.setState({ DataSource_ID: DT.DataSource_ID });
      this.setState({ ResultSource_ID: DT.ResultSource_ID });
      this.setState({ ResultSource_Content: DT.ResultSource_Content });
      this.setState({ open_options: DT.ResultSource_Content });
      this.setState({ Action_ID: DT.Action_ID });
      this.setState({ Action_Form_ID: DT.Action_Form_ID });
      this.setState({ Display_Name: DT.Display_Name });
      this.setState({ Columns: JSON.parse(data.Columns) });
      this.setState({ Parameters: JSON.parse(data.Parameters) });
      this.setState({
        enableServerSidePaging: DT.enableServerSidePaging,
        enableDownloadDT: DT.enableDownloadDT,
        enablePrintDT: DT.enablePrintDT,
        enableFilterDT: DT.enableFilterDT
      })

      this.getOptions(DT.ResultSource_ID);
    }
  }

  async componentDidMount() {
    this.setState({ loading: true });

    const { data: DS } = await getDataSources();
    this.DataSources = DS;

    this.loadDT();
    this.setState({ loading: false,can_save: true });
  }

  handleChange = (input) => {
    if (!input.name.includes("Action")) {
      this.setState({ can_save: false });
    }
    let value = input.value;
    if (input.name.includes("ID")) {
      value = parseInt(value);
    }
    this.setState({ [input.name]: value });
  };

  getConn() {
    const source = this.DataSources.find((source) => {
      return source.DataSource_ID === this.state.DataSource_ID;
    });
    return source.Connection_String;
  }

  handleResultSourceChange = async (input) => {
    this.setState({ can_save: false });
    const name = input.name.split(":").pop();
    let value = parseInt(input.value);
    this.setState({ [name]: value });

    this.getOptions(value);
  };

  handleSPVChange = async (e, value) => {
    this.setState({ ResultSource_Content: value });

    if (this.state.ResultSource_ID === ResultSource.SP) {
      const { data } = await findParameters(value, this.getConn());
      if (typeof data === "object") {
        const Parameters = data.map((par) => {
          par.Parameter_ID = 0;
          par.Default_Value = "";
          if ((par.Name).toLowerCase().includes('institution')) {
            let institutionElId = document.getElementById('userInst').value; par.Default_Value = institutionElId;
          } 
          return par;
        });
        this.setState({ Parameters });
      }
    }
  };

  handleColRemove = (index) => {
    const Columns = [...this.state.Columns];
    Columns.splice(index, 1);
    this.setState({ Columns });
  };

  handleColChange = (text, index) => {
    let Columns = [...this.state.Columns];
    Columns[index]["Column_Display_Name"] = text;
    this.setState({ Columns });
  };

  handlePrimary = (index) => {
    let Columns = this.state.Columns.map((col) => {
      col.isPrimary = false;
      return col;
    });
    Columns[index]["isPrimary"] = true;
    this.setState({ Columns });
  };

  handleVisibility = (index) => {
    let Columns = [...this.state.Columns];
    Columns[index]["Visible"] = !Columns[index]["Visible"];
    this.setState({ Columns });
  };

  findColumns = async () => {
    const { data } = await toFindColumns(
      this.state.ResultSource_ID,
      this.state.ResultSource_Content,
      this.getConn(),
      this.state.Parameters
    );

    if (typeof data === "string") {
      toaster('error', data);
    } else {
      this.setState({ can_save: true });
      const Columns = data.map((col) => {
        return {
          Column_ID: 0,
          Column_Name: col,
          Column_Display_Name: col,
          isPrimary: false,
          Visible: true,
        };
      });
      this.setState({ Columns });
    }
  };

  handleCheck = (event) => {
    this.setState({ [event.name]: !this.state[event.name] });
    event.name === 'enableServerSidePaging' && !this.state.enableServerSidePaging && (this.state.ResultSource_ID === ResultSource.SP) && toaster('info', 'Please make sure the Stored Procedure has all DT parameters specified!');
  };

  handleSave = async () => {
    const { data } = await saveDT(this.state);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_DT_SAVE_FAILED');
    } else {
      toaster('success', 'Data Table saved.');
      logActivity('/formBuilder','WIDGET_DT_SAVE_SUCCESS');
      const DT_ID = data.split(":").pop();
      this.setState({ DT_ID });
      this.loadDT();
    }
  };

  handleRemove = () => {
    this.props.onRemove(this.state.Widget_ID);
  };

  handldParChange = (text, index) => {
    const Parameters = [...this.state.Parameters];
    Parameters[index]["Default_Value"] = text;
    this.setState({ Parameters });
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const {
      DataSource_ID,
      Action_ID,
      Action_Form_ID,
      ResultSource_ID,
      Display_Name,
      ResultSource_Content,
      Widget_ID,
      open_options,
      Parameters,
      enableServerSidePaging,
      enableDownloadDT,
      enablePrintDT,
      enableFilterDT,
    } = this.state;

    return (
      <React.Fragment>
        <div className="form-group" key={Widget_ID}>
          <label htmlFor={"Display_Name" + Widget_ID}>Display Name</label>
          <input
            className="form-control"
            id={"Display_Name" + Widget_ID}
            type="text"
            name="Display_Name"
            value={Display_Name}
            onChange={(e) => this.handleChange(e.target)}
          />
        </div>
        <div className="form-group">
          <label htmlFor={"DataSource" + Widget_ID}>Data Source</label>
          <select
            id={"DataSource" + Widget_ID}
            className="form-control"
            value={DataSource_ID}
            name="DataSource_ID"
            onChange={(e) => this.handleChange(e.target)}
          >
            <option value="0">Select</option>
            {this.DataSources.map((source) => {
              return (
                <option key={source.DataSource_ID} value={source.DataSource_ID}>
                  {source.Description}
                </option>
              );
            })}
          </select>
        </div>

        {DataSource_ID !== 0 && (
          <React.Fragment>
            <div className="form-group">
              {this.ResultSources.map((source, index) => {
                return (
                  <div className="form-check form-check-inline" key={Widget_ID + source.ResultSource_Type_Name}>
                    <input
                      type="radio"
                      className="form-check-input"
                      id={Widget_ID + source.ResultSource_Type_Name}
                      name={Widget_ID + ":ResultSource_ID"}
                      value={source.ResultSource_ID}
                      checked={source.ResultSource_ID === ResultSource_ID}
                      onChange={(e) => this.handleResultSourceChange(e.target)}
                    />
                    <label
                      htmlFor={Widget_ID + source.ResultSource_Type_Name}
                      className="form-check-label"
                    >
                      {source.ResultSource_Type_Name}
                    </label>
                  </div>
                );
              })}

              {ResultSource_ID === ResultSource.Query && (
                <div>
                  <TextField
                    id={Widget_ID + "resultSourceContent"}
                    label="Enter Query"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    name="ResultSource_Content"
                    value={ResultSource_Content}
                    onChange={(e) => this.handleChange(e.target)}
                  />
                </div>
              )}

              {(ResultSource_ID === ResultSource.SP ||
                ResultSource_ID === ResultSource.View) && (
                <div>
                  <Autocomplete
                    id={Widget_ID + "resultSourceContent"}
                    options={
                      open_options
                        ? ResultSource_ID === ResultSource.SP
                          ? this.StoredProcedures
                          : this.Views
                        : []
                    }
                    getOptionLabel={(option) => option}
                    fullWidth
                    size="small"
                    value={ResultSource_Content}
                    name="ResultSource_Content"
                    onChange={this.handleSPVChange}
                    inputValue={open_options}
                    onInputChange={(e, val) => {
                      this.setState({ open_options: val });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          ResultSource_ID === ResultSource.SP
                            ? "Stored Procedure Name"
                            : "View Name"
                        }
                      />
                    )}
                  />
                </div>
              )}

              {ResultSource_ID === ResultSource.SP &&
                Parameters.length > 0 &&
                Parameters.map((par, idx) => {
                  return (
                    <TextField
                      id={Widget_ID + "." + par.Name}
                      key={Widget_ID + "." + par.Name}
                      label={par.Name + "(" + par.Type + ")"}
                      placeholder="Default Value"
                      fullWidth
                      value={par.Default_Value}
                      onChange={(e) =>
                        this.handldParChange(e.target.value, idx)
                      }
                    />
                  );
                })}
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor={"row_action" + Widget_ID}>
                  Row Click Event Action
                </label>
                <select
                  id={"row_action" + Widget_ID}
                  name="Action_ID"
                  value={Action_ID}
                  className="form-control"
                  onChange={(e) => this.handleChange(e.target)}
                >
                  <option value="0">Select</option>
                  {this.RowActions.map((action) => {
                    return (
                      <option key={action.Action_ID} value={action.Action_ID}>
                        {action.Action_Name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group col-md-8">
                <label htmlFor={"action_form" + Widget_ID}>Form</label>
                <select
                  id={"action_form" + Widget_ID}
                  className="form-control"
                  name="Action_Form_ID"
                  value={Action_Form_ID}
                  onChange={(e) => this.handleChange(e.target)}
                >
                  <option value="-1">Select</option>
                  {Action_ID === RowActions.Navigate && (
                    <option value="0">On user selection</option>
                  )}
                  {this.Forms.map((form) => {
                    return (
                      <option key={form.Form_ID} value={form.Form_ID}>
                        {form.Form_Name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th className="text-center">Visible</th>
                  <th>
                    Column Name{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Find column names</Tooltip>}
                    >
                      <span
                        className="badge badge-success pointer"
                        onClick={this.findColumns}
                      >
                        <Icon.Search size={16} />
                      </span>
                    </OverlayTrigger>
                  </th>

                  <th>Display Name</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.Columns.map((column, idx) => {
                  return (
                    <tr key={column.Column_Name}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={column.Visible}
                          onChange={() => this.handleVisibility(idx)}
                        />
                      </td>
                      <td>{column.Column_Name}</td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          value={column.Column_Display_Name}
                          onChange={(e) =>
                            this.handleColChange(e.target.value, idx)
                          }
                        />
                      </td>
                      <td>
                        {column.isPrimary && (
                          <div className="badge badge-primary">
                            Primary Key{" "}
                          </div>
                        )}
                        {!column.isPrimary && (
                          <div
                            className="pointer badge badge-light"
                            onClick={() => this.handlePrimary(idx)}
                          >
                            Make Primary
                          </div>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-icon btn-transparent-dark btn-sm"
                          onClick={() => this.handleColRemove(idx)}
                        >
                          <Icon.Trash2 />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <hr className="my-4" />
            <label>Display Options</label>
            <div className='row'>
              <div className="col-md-2 form-group">
                <div className="custom-control custom-switch mt-n2">
                  <input
                    type="checkbox"
                    name='enableServerSidePaging'
                    id={'rowEnableServerSidePagingSwitch' + Widget_ID}
                    className="custom-control-input"
                    checked={enableServerSidePaging}
                    value={enableServerSidePaging}
                    onChange={(e) => this.handleCheck(e.target)}
                  />
                  <br />
                  <label htmlFor={'rowEnableServerSidePagingSwitch' + Widget_ID} className="custom-control-label">Server-Side Paging</label>
                </div>
              </div>
              <div className="col-md-2 form-group">
                <div className="custom-control custom-switch mt-n2">
                  <input
                    type="checkbox"
                    name='enableDownloadDT'
                    id={'rowEnableSDownloadDTSwitch' + Widget_ID}
                    className="custom-control-input"
                    checked={enableDownloadDT}
                    value={enableDownloadDT}
                    onChange={(e) => this.handleCheck(e.target)}
                  />
                  <br />
                  <label htmlFor={'rowEnableSDownloadDTSwitch' + Widget_ID} className="custom-control-label">Download Table</label>
                </div>
              </div>
              <div className="col-md-2 form-group">
                <div className="custom-control custom-switch mt-n2">
                  <input
                    type="checkbox"
                    name='enablePrintDT'
                    id={'rowEnableSPrintDTSwitch' + Widget_ID}
                    className="custom-control-input"
                    checked={enablePrintDT}
                    value={enablePrintDT}
                    onChange={(e) => this.handleCheck(e.target)}
                  />
                  <br />
                  <label htmlFor={'rowEnableSPrintDTSwitch' + Widget_ID} className="custom-control-label">Print Table</label>
                </div>
              </div>
              <div className="col-md-2 form-group">
                <div className="custom-control custom-switch mt-n2">
                  <input
                    type="checkbox"
                    name='enableFilterDT'
                    id={'rowEnableFilterDTSwitch' + Widget_ID}
                    className="custom-control-input"
                    checked={enableFilterDT}
                    value={enableFilterDT}
                    onChange={(e) => this.handleCheck(e.target)}
                  />
                  <br />
                  <label htmlFor={'rowEnableFilterDTSwitch' + Widget_ID} className="custom-control-label">Filter Table</label>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-primary mr-2"
            onClick={this.handleSave}
            disabled={!this.state.can_save}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WDataTable;
